import { SUBSCRIPTION_STOPS } from '../../../../constants/Copy';
import { friendlyDate } from '../../../../helpers/datetime';
import React from 'react';

const TermedCopy = ({ subscription }) => {
	return <p>{`${SUBSCRIPTION_STOPS} ${friendlyDate(subscription.endDate)}`}</p>;
};

export default TermedCopy;
